<template>
    <div id="EnFooterSection">
        <section id="footer-sitemap">
            <div class="sitemap-container w3 w80-mb lh18">
                <div class="sitemap-group" v-for="(item, index) of enNavItems" :key="'sitemap-group-' + index">
                    <h3 class="f16 f14-mb bold">{{ item.title }}</h3>
                    <p v-for="subitem of item.items" :key="subitem.title" class="f14 f12-mb">
                        <router-link v-if="subitem.routeUrl" :to="subitem.routeUrl" tabindex="0" role="button">{{ subitem.title }}</router-link>
                        <a v-else-if="subitem.href" :href="subitem.href" tabindex="0" role="button" target="_blank">{{ subitem.title }}</a>
                    </p>
                </div>
            </div>
        </section>
        <section id="footer-address">
            <div class="footer-address-container f14 f12-mb lh15 w3 w80-mb">
                <img :src="require('@/assets/png/horizontal-logo.png')" alt="環境部資源循環署完整LOGO" />
                <address>
                    <div class="footer-address-left">
                        <h3 class="bold">Copyright © Environmental Protection Administration</h3>
                        <div class="address-wrap">
                            <p>
                                (02)-23705888<br />
                                13F, No. 99, Hengyang Road, <br />
                                Zhongzheng District, Taipei City
                            </p>
                            <a class="medium f12" tabindex="0" role="button" target="_blank" href="https://recycle.moenv.gov.tw/Introduction/ContactInfo"
                                ><i class="icon-map"></i>Location map</a
                            >
                        </div>
                    </div>
                    <div class="footer-address-right">
                        <span class="bold">Resource recycling hotline: 0800-085-717</span>
                        <div class="social-media-group">
                            <a tabindex="0" role="button" target="_blank" href="https://r-paper.moenv.gov.tw/index.aspx"
                                ><i class="icon-newspaper"></i><span style="display: none">回收綠報報</span></a
                            >

                            <a tabindex="0" role="button" target="_blank" href="https://www.facebook.com/MOENR.TW/"
                                ><i class="icon-facebook"></i><span style="display: none">Facebook</span></a
                            >
                        </div>
                    </div>
                </address>
            </div>
        </section>
        <section id="footer-links-counts">
            <div class="footer-links-counts-container f14 f12-mb w1 w90-mb">
                <div class="footer-links">
                    <a tabindex="0" role="button" v-for="item of links" :key="item.title" :href="item.href" target="_blank">{{ item.title }}</a>
                </div>
                <div class="footer-counts">
                    <span>Visitors: {{ totalViewCount.toLocaleString('en-US') }}</span>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'EnFooterSection',
}
</script>
<script setup>
import { ref } from 'vue'
import { getConfigCount } from '@/service/apis'
import getNavItems from '@/data/getNavItems.js'
const { enNavItems } = getNavItems()
const links = [
    {
        title: 'Privacy Protection Policy',
        href: 'https://www.moenv.gov.tw/EN/49AACA21659166DB',
    },
    {
        title: 'Website Security Policy',
        href: 'https://www.moenv.gov.tw/EN/93AB5809EC92B90D',
    },
    {
        title: 'Open Government Declaration',
        href: 'https://www.moenv.gov.tw/en/6CA206960EF0DAEF',
    },
    {
        title: 'Contact Us',
        href: 'https://epamail.moenv.gov.tw/front/mailboxhome',
    },
]
const todayViewCount = ref(0)
const totalViewCount = ref(0)
async function initCount() {
    let res = await getConfigCount()
    todayViewCount.value = res.todayViewCount
    totalViewCount.value = res.totalViewCount
}
initCount()
</script>
<style lang="scss" scoped>
$address-color: #324671;
$links-counts-color: #70809c;

#footer-sitemap {
    color: $gray6;
    background-color: $grayF;
    padding: 40px 0;
    .sitemap-container {
        display: grid;
        grid-template: auto / repeat(2, 1fr);
        grid-gap: 50px;
    }
    .sitemap-group {
        h3,
        p {
            line-height: 1.2em;
            padding: 0.3em 0;
        }
    }
}
#footer-address {
    color: $theme0;
    background-color: $address-color;
    .footer-address-container {
        padding: 50px 0 30px;
    }
    img {
        display: block;
        width: 150px;
        height: 150px;
    }
    address {
        margin-top: 30px;
    }
    .footer-address-left {
        h3 {
            margin-bottom: 1em;
        }
        a {
            display: inline-block;
            margin-top: 10px;
            margin-left: 10px;

            padding: 5px 10px;
            border-radius: 30px;
            color: $address-color;
            background-color: $theme0;
            transition: 0.3s;
            height: max-content;
            i.icon-map {
                position: relative;
                top: 2px;
                margin-right: 3px;
            }

            &:hover,
            &:focus {
                color: lighten($address-color, 10%);
                background-color: lighten($theme0, 10%);
            }
        }
    }
    .footer-address-right {
        span {
            display: inline-block;
            padding: 10px;
            border-radius: 10px;
            border: 2px solid $theme0;
        }
        .social-media-group {
            margin: 10px 0;
            a {
                margin-left: 8px;
                color: $theme0;
                font-size: 32px;
                transition: 0.3s;
                &:hover,
                &:focus {
                    color: lighten($theme0, 10%);
                }
            }
        }
    }

    @media screen and (min-width: 1200px) {
        address {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        .address-wrap {
            display: flex;
        }
        .social-media-group {
            text-align: right;
        }
    }
    @media screen and (max-width: 1199px) {
        .footer-address-right {
            padding-top: 3em;
        }
    }
}
#footer-links-counts {
    padding: 20px 0;
    color: $white;
    background-color: $links-counts-color;

    .footer-links {
        a {
            border-right: 1px solid $white;
            &:last-child {
                border-right: none;
            }
        }
    }
    div {
        span,
        a {
            display: inline-block;
            padding: 0 1em;
            line-height: 1em;
        }
    }

    @media screen and (min-width: 768px) {
        .footer-links-counts-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
    @media screen and (max-width: 767px) {
    }
}
</style>
